import { render, staticRenderFns } from "./DefaultInfoViewer.vue.js?vue&type=template&id=45704f12!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./DefaultInfoViewer.vue?vue&type=template&id=45704f12"
import script from "./DefaultInfoViewer.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./DefaultInfoViewer.vue?vue&type=script&lang=js"
export * from "./DefaultInfoViewer.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./DefaultInfoViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports